module.exports = __webpack_public_path__ + "img/list_filled_24.c14f5f8b.svg";